import { render, staticRenderFns } from "./MainNavigationContainer.vue?vue&type=template&id=1bff5216&scoped=true&"
import script from "./MainNavigationContainer.vue?vue&type=script&lang=js&"
export * from "./MainNavigationContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bff5216",
  null
  
)

export default component.exports